import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../img/pepe.png';
import jImg from '../img/moldura.png';
import lImg from '../img/moldu.png';
import { ChevronLeft, ChevronRight, Circle, CircleDot } from 'lucide-react';

const ModernCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const slides = [
    {
      image: eImg,
      title: "Premium",
      subtitle: "Exclusive Collection",
      description: "Discover the art in every detail of our handcrafted moldings",
      tag: "New"
    },
    {
      image: jImg,
      title: "Contemporary Design",
      subtitle: "Innovation and Style",
      description: "Moldings that transform spaces with modern elegance",
      tag: "Featured"
    },
    {
      image: lImg,
      title: "Perfect Finishes",
      subtitle: "Superior Quality",
      description: "Experience and precision in every piece we create",
      tag: "Popular"
    }
  ];

  const handleNavigate = () => {
    navigate('/products');
  }; 

  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isHovered]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div 
      className="relative w-full h-screen max-h-[600px] overflow-hidden bg-gray-900 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Slides Container */}
      <div className="relative w-full h-full">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 w-full h-full transition-all duration-700 ease-in-out transform
              ${index === currentSlide ? 'opacity-100 translate-x-0 z-10' : 
                index < currentSlide ? 'opacity-0 -translate-x-full z-0' : 'opacity-0 translate-x-full z-0'}`}
          >
            {/* Background Pattern */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-purple-900/20 z-10" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.6)_100%)]" />
            
            {/* Image */}
            <img
              src={slide.image}
              alt={slide.title}
              className="object-cover object-center w-full h-full transform transition-transform duration-15000 hover:scale-110"
            />
            
            {/* Content Overlay */}
            <div className="absolute inset-0 flex items-center justify-center z-20">
              <div className="max-w-4xl mx-6 text-center">
                <div className="inline-block px-4 py-2 mb-6 bg-white/10 backdrop-blur-md rounded-full">
                  <span className="text-sm font-medium text-white">{slide.tag}</span>
                </div>
                <h3 className="text-lg text-white/90 font-medium mb-3 tracking-wider">
                  {slide.subtitle}
                </h3>
                <h2 className="text-5xl font-bold text-white mb-6 tracking-tight">
                  {slide.title}
                </h2>
                <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
                  {slide.description}
                </p>
                <button 
                 onClick={handleNavigate}
                className="px-8 py-3 bg-white text-gray-900 rounded-lg font-semibold 
                  hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105">
                  Explore Collection
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Controls */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/50 to-transparent z-30" />
      
      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 p-3 rounded-full
          bg-black/30 backdrop-blur-sm hover:bg-white/30 transition-all duration-300
          opacity-0 group-hover:opacity-100 transform -translate-x-10 group-hover:translate-x-0"
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 p-3 rounded-full
          bg-black/30 backdrop-blur-sm hover:bg-white/30 transition-all duration-300
          opacity-0 group-hover:opacity-100 transform translate-x-10 group-hover:translate-x-0"
      >
        <ChevronRight className="w-6 h-6 text-white" />
      </button>

      {/* Bottom Navigation */}
      <div className="absolute bottom-8 left-0 right-0 z-30">
        <div className="flex flex-col items-center">
          {/* Slide Indicators */}

          
          {/* Progress Bar */}
          <div className="w-64 h-1 bg-white/20 rounded-full overflow-hidden">
            <div 
              className="h-full bg-white/80 transition-all duration-500 ease-out"
              style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModernCarousel;
